import { GlobalState } from 'ha/types/store';

export const getFeatureFlags = (s: GlobalState) => s.FEATURE_FLAGS;
